import { computed } from 'vue';

import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export const makeResponsiveProps = propsFactory(
  {
    /**
     * Соотношение сторон изображения. Для изображения 1920x1080px это будет 1,7778. Если это значение не указано, оно будет рассчитано автоматически.
     */
    aspectRatio: {
      type: [String, Number] as PropType<string | number>,
      default: undefined
    },
    /**
     * Пользовательский класс для элемента внутреннего содержимого.
     */
    contentClass: {
      type: String as PropType<string>,
      default: undefined
    },
    /**
     * Отображается как инлайн-элемент вместо блока, также отключает flex-grow.
     */
    inline: {
      type: Boolean as PropType<boolean>,
      default: undefined
    }
  },
  'responsive'
);

export function useAspectStyles(props: { aspectRatio?: string | number }) {
  const aspectStyles = computed(() => {
    const ratio = Number(props.aspectRatio);

    return ratio ? { paddingBottom: String((1 / ratio) * 100) + '%' } : undefined;
  });

  return {
    aspectStyles
  };
}
